import { render } from "./Button.htm?vue&type=template&id=58e1c1af&scoped=true"
import script from "./Button.js?vue&type=script&lang=js"
export * from "./Button.js?vue&type=script&lang=js"

import "./Button.scss?vue&type=style&index=0&id=58e1c1af&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e1c1af"]])

export default __exports__